import { useReducer, useEffect, useState } from "react";
import { AppContext } from "./context";
import { appReducer, loadStateFromStorage } from "./appReducer";

export const AppProvider = ({ children }) => {
  // Cargar estado inicial desde localStorage
  const [state, dispatch] = useReducer(appReducer, null, loadStateFromStorage);
  const [loginOpen, setLoginOpen] = useState(false);

  const openLoginModal = () => {
    console.log("trying to set loginOpen to: ", !loginOpen);
    setLoginOpen(!loginOpen);
  };
  const getLoginModalState = () => loginOpen;

  // Opcional: Limpiar localStorage cuando sea necesario
  useEffect(() => {
    // Escuchar eventos de limpieza de storage (opcional)
    const handleStorageClean = () => {
      dispatch({ type: "CLEAR_STORAGE" });
    };

    // Limpiar al cerrar ventana (opcional)
    const handleBeforeUnload = () => {
      // Aquí podrías hacer validaciones antes de cerrar
    };

    window.addEventListener("storage-clean", handleStorageClean);
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("storage-clean", handleStorageClean);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <AppContext.Provider
      value={{ state, dispatch, openLoginModal, getLoginModalState }}
    >
      {children}
    </AppContext.Provider>
  );
};
